export enum AssetAction {
    selectAll = 'SELECT_ALL',
    selectVisible = 'SELECT_VISIBLE',
    selectNone = 'SELECT_NONE',
    addCollection = 'ADD_COLLECTION',
    editAssets = 'EDIT_ASSETS',
    shareAssets = 'SHARE_ASSETS',
    downloadAssets = 'DOWNLOAD_ASSETS',
    downloadAllAssets = 'DOWNLOAD_ALL_ASSETS',
    nextAsset = 'NEXT_ASSET',
    prevAsset = 'PREV_ASSET',
    none = '',
    deleteAssets = 'DELETE_ASSETS',
    reloadAssets = 'RELOAD_ASSETS'
}
